import React from "react";
import { motion } from "framer-motion";
import { AI_CAPABILITIES_DATA } from "config/data";
import { Reveal, StaggerGroup, fadeUp } from "components/ui/motion";

const AICapabilities = () => {
  return (
    <section className="bg-white py-20">
      <div className="container-tt">
        <Reveal className="max-w-2xl">
          <span className="eyebrow !text-brand-600">
            <span className="h-1.5 w-1.5 rounded-full bg-accent" />
            What we bring to the table
          </span>
          <h2 className="mt-4 text-3xl font-semibold text-ink sm:text-4xl">
            AI woven into every layer of your product
          </h2>
          <p className="mt-4 text-base text-slate-500">
            We don't bolt AI on as an afterthought. We design intelligent behavior into the core of your
            mobile and web apps — so they feel effortless, personal, and a step ahead.
          </p>
        </Reveal>

        <StaggerGroup className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" stagger={0.1}>
          {AI_CAPABILITIES_DATA.map((cap, i) => (
            <motion.div
              key={cap.title}
              variants={fadeUp}
              whileHover={{ y: -6 }}
              className="group relative rounded-2xl border border-slate-100 bg-white p-7 shadow-card transition-colors duration-300 hover:border-brand-200"
            >
              <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-brand-gradient text-sm font-bold text-white shadow-glow">
                {String(i + 1).padStart(2, "0")}
              </div>
              <h3 className="mt-5 text-lg font-semibold text-ink">{cap.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-500">{cap.desc}</p>
            </motion.div>
          ))}
        </StaggerGroup>
      </div>
    </section>
  );
};

export default AICapabilities;
